/**
 * Calculate percentage loaded based on current values
 */
export const percentLoaded = (loaded, total) =>
    Math.ceil((loaded / total) * 100);

/**
 * Performs an HTTP request with upload progress
 *
 * @param {string} url - resource to post
 * @param {FormData} data - FormData to post
 * @param {(percentLoaded: number) => void} onProgress - function that will be invoked on each progress event
 * @returns Promise<string>
 */
export const httpWithUploadProgress = (url, data, onProgress) =>
    new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        xhr.addEventListener('load', () => {
            if (xhr.status >= 300) {
                reject();
            } else {
                resolve(xhr.responseText);
            }
        });
        xhr.addEventListener('error', () => reject());
        xhr.addEventListener('abort', () => reject());
        if (xhr.upload) {
            xhr.upload.addEventListener('progress', (event) => {
                if (
                    Number.isFinite(event.loaded) &&
                    Number.isFinite(event.total)
                ) {
                    onProgress(percentLoaded(event.loaded, event.total));
                }
            });
        }
        xhr.open('POST', url, true);
        xhr.send(data);
    });
